const resources = {
  general: {
    search: 'Hľadaj',
    reset: 'Reset',
    close: 'Zavri',
    create: 'Vytvor',
    delete: 'Zmaž',
    edit: 'Uprav',
    add: 'Pridaj',
    name: 'Meno',
    action: 'Akcia | Akcie',
    ipAddress: 'IP adresa',
    sync: 'Synchronizuj',
    syncStatus: 'Stav synchronizácie',
    version: 'Verzia',
    note: 'Poznámka',
    general: 'Všeobecné',
    stats: 'Štatistiky',
    macAddress: 'MAC adresa',
    type: 'Typ',
    size: 'Veľkosť',
    true: 'Áno',
    false: 'Nie',
    content: 'Obsah',
    emailAddress: 'Emailová adresa',
    next: 'Ďaľší',
    cancel: 'Zrušiť',
    assign: 'Priraď',
    user: 'Používateľ | Používatelia',
    disabled: 'Deaktivované',
    language: 'Jazyk',
    english: 'Anglický',
    slovak: 'Slovenský',
    news: 'News',
    account: 'Učet | Učty',
    subscription: 'Subscription | Subscriptions',
    status: 'Status | Statusy',
  },
  app: {
    navigation: 'Navigácia',
    schedule: 'Plán | Plány',
    design: 'Dizajn',
    box: 'Box | Boxy',
    library: 'Knižnica',
    media: 'Média',
    setting: 'Nastavenie | Nastavenia',
    monitoring: 'Monitoring',
    administration: 'Administrácia',
    layoutEditor: 'Editor rozhrania',
    userManagement: 'Správa používateľov',
    organizationManagement: 'Správa organizácií',
    boxManagement: 'Správa boxov',
    device: 'Zariadenie | Zariadenia',
    screen: 'Obrazovka | Obrazovky',
    layout: 'Rozhranie | Rozhrania',
    dashboard: 'Dashboard',
    playlist: 'Playlist | Playlisty',
    management: 'Správa',
    planning: 'Plánovanie',
    newsEditor: 'Editor noviniek',
    specialWidget: 'Special widget | Special widgets',
  },
  auth: {
    login: 'Login',
    email: 'Email',
    password: 'Heslo',
    register: 'Registrovať',
    forgotPassword: 'Zabudnuté heslo?',
    username: 'Používateľské meno',
    confirmPassword: 'Kontrola hesla',
    reset: 'Reset',
  },
  admin: {
    createUser: 'Vytvor používateľa',
    deleteUser: 'Zmaž používateľa | Zmaž používateľov',
    editUser: 'Uprav používateľa',
    createOrganization: 'Vytvor organizáciu',
    deleteOrganization: 'Zmaž organizáciu | Zmaž organizácie',
    editOrganization: 'Uprav organizáciu',
    confirmPassword: 'Potvrdenie hesla',
    organization: 'Organizácia | Organizácie',
    role: 'Rola | Role',
    usersFilterPlaceholder: 'Meno alebo email',
    organizationsFilterPlaceholder: 'Meno',
    box: 'Box | Boxy',
    boxesFilterPlaceholder: 'Meno, stav synchronizácie alebo verzia',
    deleteBox: 'Zmaž box | Zmaž boxy',
    editBox: 'Uprav box | Uprav boxy',
    createBox: 'Vytvor box | Vytvor boxy',
    permission: 'Právo | Práva',
    subscriptionUser: 'Používateľ s predplatným',
    maxBoxes: 'Max počet boxov',
    icon: 'Ikona | Ikony',
    specialWidget: 'Špeciálny widget | Špeciálne widgets',
    specialWidgetsFilterPlaceholder: 'Názov alebo typ',
    createSpecialWidget: 'Vytvor špeciálny widget',
    deleteSpecialWidget: 'Zmaž špeciálny widget | Zmaž špeciálne widgety',
    editSpecialWidget: 'Uprav špeciálny widget',
    audioSource: 'Audio URL',
    imageSource: 'Image URL',
    videoSource: 'Video URL',
    pdfSource: 'PDF URL',
    webSource: 'Web URL',
  },
  box: {
    filterPlaceholder: 'Meno, IP adresa, stav synchronizácie alebo verzia',
    boxDateTime: 'Dátum a čas boxu',
    boxUptime: 'Uptime boxu',
    boxHddTemperature: 'Teplota HDD boxu',
    boxHddUsage: 'Využitie HDD boxu',
    boxCpuLoad: 'Využitie CPU boxu',
    boxRamUsage: 'Využitie RAM boxu',
    boxSwapUsage: 'Využitie SWAPu',
    videoOutput: 'Video výstup | Video výstupy',
    displayVolume: 'Hlasitosť displeja {identifier}',
    volume: 'Hlasitosť',
    displayResolution: 'Rozlíšenie displeja',
    boxStorageSpace: 'Miesto na HDD',
    deleteBox: 'Zmaž box | Zmaž boxy',
    syncBox: 'Synchronizuj box | Synchronizuj boxy',
    lastStatusUpdate: 'Posledná aktualizácia stavu boxu',
    osVersion: 'Verzia OS Android',
    activated: 'Aktivovaný',
  },
  library: {
    filterPlaceholder: 'Meno alebo typ',
    playlistsFilterPlaceholder: 'Meno',
    deleteMedia: 'Chcete zmazať tieto médiá?',
    uploadPlaceholder: 'Presunťe sem súbory alebo kliknite pre nahratie',
    preview: 'Náhľad',
    createPlaylist: 'Vytvor playlist',
    editPlaylist: 'Uprav playlist',
    assignPlaylist: 'Priraď playlist',
    deletePlaylist: 'Zmaž playlist | Zmaž playlisty',
    playlistEditor: 'Playlist editor',
    event: 'Udalosť | Udalosti',
  },
  schedule: {
    createNewEvent: 'Vytvor novú udalosť',
    editEvent: 'Uprav udalosť',
    title: 'Nadpis',
    date: 'Dátum',
    startDate: 'Začiatočný dátum',
    endDate: 'Konečný dátum',
    startTime: 'Začiatočný čas',
    endTime: 'Konečný čas',
    color: 'Farba | Farby',
    month: 'Mesiac | Mesiace',
    week: 'Týždeň | Týždne',
    year: 'Rok | Roky',
    repeat: 'Opakovanie',
    daily: 'Denne',
    weekly: 'Týždenne',
    monthly: 'Mesačne',
    monday: 'Pondelok',
    tuesday: 'Utorok',
    wednesday: 'Streda',
    thursday: 'Štvrtok',
    friday: 'Piatok',
    saturday: 'Sobota',
    sunday: 'Nedeľa',
    january: 'Január',
    february: 'Február',
    march: 'Marec',
    april: 'Apríl',
    may: 'Máj',
    june: 'Jún',
    july: 'Júl',
    august: 'August',
    september: 'September',
    october: 'Október',
    novermber: 'November',
    december: 'December',
  },
  design: {
    position: 'Pozícia',
    size: 'Veľkosť',
    audioControls: 'Ovládanie audia',
    animation: 'Animácia | Animácie',
    widget: 'Widget | Widgety',
    contentBrowser: 'Prehliadač obsahu',
    library: 'Knižnica',
    property: 'Vlastnosť | Vlastnosti',
    noWidgetSelectedMsg: 'Žiadny widget nie je zvolený',
    noWidgetSelectedDescription: 'Kliknite na jeden z widgetov v editore rozhrania aby ste upravili jeho vlastnosti',
    noWidgetsMsg: 'Žiadne widgety',
    noWidgetsDescription: 'Potiahnite widget z prehliadaču obsahu do editora rozhrania na vytvorenie widgetu',
    noLibraryMediaMsg: 'Žiadne média',
    noLibraryMediaDescription: 'Prosím nahrajte média na stránke Média pre použitie v editore rozhrania',
    visible: 'Viditeľný',
    top: 'Hore',
    left: 'Vľavo',
    center: 'Stred',
    right: 'Vpravo',
    bottom: 'Dole',
    vertical: 'Vertikálne',
    horizontal: 'Horizontálne',
    color: 'Farba | Farby',
    background: 'Pozadie',
    text: 'Text',
    height: 'Výška',
    width: 'Šírka',
    font: 'Font',
    alignment: 'Zarovnanie',
    image: 'Obrázok',
    feedTextPlaceholder: 'Text feedu',
    video: 'Video',
    webpage: 'Web stránka',
    youtube: 'YouTube',
    shellCommand: 'Shell príkaz',
    pdf: 'PDF',
    url: 'URL',
    ticker: 'Ticker',
    audio: 'Audio',
    clock: 'Hodiny',
    embed: 'Embed',
    powerpoint: 'Powerpoint',
    event: 'Udalosť | Udalosti',
    newEvent: 'Nová udalosť',
    uploadMedia: 'Nahraj média',
    startTime: 'Začiatočný čas',
    endTime: 'Konečný čas',
    createEvent: 'Vytvor udalosť',
    type: 'Typ | Typy',
    allowDeformation: 'Povoľ deformáciu',
    margin: 'Vonkajšie odsadenie',
    padding: 'Vnútorné odsadenie',
    zIndex: 'Z-index',
    value: 'Hodnota',
    newAnimation: 'Nová animácia',
    createAnimation: 'Vytvor animáciu',
    startPosition: 'Začiatočná pozícia',
    endPosition: 'Konečná pozícia',
    duration: 'Dĺžka (sekundy)',
    repeat: 'Opakovanie',
    togglePicker: 'Zobraz RGB picker',
    rotation: 'Rotácia',
    createTimelinePoint: 'Vytvor bod na časovej osi',
    newState: 'Nový stav',
    state: 'Stav | Stavy',
    startOpacity: 'Začiatočná viditeľnosť',
    endOpacity: 'Konečná viditeľnosť',
    degree: 'Stupne | Stupňov',
    createScreen: 'Vytvor obrazovku | Vytvor obrazovky',
    deleteScreen: 'Zmaž obrazovku | Zmaž obrazovky',
    screensFilterPlaceholder: 'Meno, šírka alebo výška',
    createLayout: 'Vytvor rozhranie | Vytvor rozhrania',
    deleteLayout: 'Zmaž rozhranie | Zmaž rozhrania',
    layoutsFilterPlaceholder: 'Meno',
    assignLayout: 'Priraď rozhranie | Priraď rozhrania',
    webContent: 'Web obsah',
    option: 'Vlastnosť | Vlastnosti',
    opacity: 'Viditeľnosť',
    start: 'Štart',
    end: 'Koniec',
    time: 'Čas | Časy',
    connection: 'Pripojenie',
    address: 'Adresa | Adresy',
    port: 'Port | Porty',
    password: 'Heslo',
    vncViewer: 'VNC obrazovka',
    durationBetweenPages: 'Doba medzi stránkami',
    loop: 'Opakovanie',
    volume: 'Volume',
    hardwareAcceleration: 'Hardvérová akcelerácia',
    twitter: 'Twitter',
    rss: 'RSS',
    facebook: 'Facebook',
    twitterOptions: 'Nastavenia Twittera',
    hashtag: 'Hashtag',
    user: 'Používateľské meno',
    facebookPageID: 'ID Facebook stránky',
    youtubeOptions: 'Nastavenia YouTube',
    special: 'Špeciálne',
    web: 'Web',
    videoPlayerType: 'Typ video prehrávača',
    magio: 'Magio TV',
    magioOptions: 'Nastavenia Magio',
  },
  settings: {
    invoice: 'Faktúra | Faktúry',
    invoicesFilterPlaceholder: 'Suma alebo dátum',
    amount: 'Suma',
    date: 'Dátum',
  },
};

export default resources;
